module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Page 1\n  </title>\n  <path d=\"M24 0c-4.8 0-7.2 6-12 6S4.8 0 0 0h24z\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/dropdown-bump.svg
// module id = 3703
// module chunks = 168707334958949